import * as React from "react";
import { matchPath, useLocation } from "react-router";
import { ChefEntrepriseDetail, ChefEntrepriseDetailDoublons } from ".";
import { ChefsEntrepriseDoublonSearchDtoFromJSON } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { useTabMessage } from "../../../../../hooks";

export interface IChefEntrepriseDetailSwitchProps {}

export const ChefEntrepriseDetailSwitch: React.FunctionComponent<IChefEntrepriseDetailSwitchProps> = props => {
  const [sObj, setSObj] = React.useState(ChefsEntrepriseDoublonSearchDtoFromJSON({}));
  const { pathname, search } = useLocation();
  const cfs = React.useMemo(() => new URLSearchParams(search).get("cfs"), [search]);
  const { messageValue, clearMessageValue } = useTabMessage(cfs);

  React.useEffect(() => {
    if (!!messageValue) {
      setSObj(messageValue);
      clearMessageValue();
    }
  }, [clearMessageValue, messageValue]);
  if (
    matchPath(pathname, {
      path: `${ERoutes.chefEntreprise}/-1/:tab/checkDoublons`
    })
  ) {
    return <ChefEntrepriseDetailDoublons setBaseData={setSObj} />;
  } else {
    return <ChefEntrepriseDetail baseData={sObj} />;
  }
};
